/*
 * Copyright (c) Arbeidskracht Groep B.V. - all rights reserved
 */

import React, {ReactNode} from 'react';
import {Container} from 'react-bootstrap';
import Props from './Props';
import Notifications from '@pompkracht/react-notifications/dist';

class Layout extends React.Component<Props> {

	static defaultProps: Partial<Props> = {
		children: undefined
	};

	render(): ReactNode {
		const props: Readonly<Props> = this.props;

		return (
			<div>
				<Container fluid={true}>{props.children}</Container>
				<Notifications/>
			</div>
		);
	}
}

export default Layout;
